import nanoajax from "nanoajax";
import slugify from "slugify";
import moment from "moment";
import Swiper from "swiper";
import Trends from "../Trends";
import {
	holidayCarnaval,
	holidayAnoNovo,
	holidayDiaDasMaes,
	holidayDiaDosNamorados,
	holidayDiaDoTrabalho,
	holidayFestaJunina,
	holidayIndependenciaDoBrasil,
	holidayNossaSenhora,
	holidayProclamacaoDaRepublica,
	holidaySemanaSanta,
	holidayCorpusChristi,
	holidayFinados
} from "../../../shared/holidaysTexts";
import { getItemsOnBlog } from "../../../shared/utils";
import { NEARBY_PLACES_API, BFF_API } from "../../../shared/constants";
import { stretchFrom } from "../../../searchform";
import { formatCurrency } from "../../../shared/utils";

export const createComponentsFeriado = (nome_feriado, minDate, maxDate) => {
	const urlBuscaPassagens = BFF_API;

	const limitBuscaPassagens = 12;
	const limitBuscaPassagensAeroporto = 1;
	const limitPostsBlog = 4;
	let sizeBlog = 0;

	if (document.body.className.match(`.holidays.${nome_feriado}`)) {
		const createErrorHtml = (elevenmonths, { node = null, nome_feriado = nome_feriado } = {}) => {
			let titleError;
			let subtitleError;

			const backin = moment(minDate)
				.subtract(11, "months")
				.format("DD/MM/YY");

			if (elevenmonths === true) {
				titleError = `Opa! Ainda não temos ofertas para essa data, mas você ainda pode voar com mais economia. Tente de novo no dia ${backin}`;
				subtitleError =
					"Deixe seu e-mail abaixo para aproveitar nossas ofertas e voar com descontos o ano todo.";
			} else {
				titleError =
					"Opa! Ainda não temos ofertas para essa data, mas você ainda pode voar com mais economia.";
				subtitleError =
					"Deixe seu e-mail abaixo para aproveitar nossas ofertas e voar com descontos o ano todo.";
			}

			const htmlError = `<section class="newsletter" data-section="newsletter">
              <div class="container-fluid">
                  <div class="row">
                      <div class="col-xs-16">
                        <div class="col-xs-16 box-unique">
                          <div class="col-xs-16 newsletter-border">
                            <div class="newsletter-box box-default">
                              <form name="formNewsletter" id="formNewsletter" class="form-newsletter" novalidate>
                                  <h3>${titleError}</h3>
                                  <h4>${subtitleError}</h4>
                                  <div class="col-md-13 no-padding">
                                      <div class="form-group">
                                          <i class="icon-email form-control-feedback"></i>
                                          <input type="email" class="form-control" name="email"  id="newsletter-email" required placeholder="Deixe aqui o e-mail que mais usa">
                                      </div>
                                  </div>
                                  <div class="col-md-3 no-padding-horizontal">
                                      <button type="submit" name="button" class="btn btn btn-success">
                                          <i class="icon-arrow-right"></i>Receber ofertas
                                      </button>
                                  </div>
                                  <div class="col-xs-16 no-padding hidden">
                                      <div class="alert alert-danger validate-error-msg">
                                          {#<li ng-show="formNewsletter.$invalid || vm.newsletter.status > 201" class="title">Ops... algo deu errado :(</li>#}
                                          <div class="alert--icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <div class="alert--message">
                                              <p class="hidden email-validation email-invalid">Email inválido!</p>
                                          </div>
                                      </div>
                                  </div>
                              </form>
                              <div class="alert alert-success hidden validate-success-msg">
                                  <div class="alert--icon">
                                      <i class="icon-check"></i>
                                  </div>
                                  <div class="alert--message">
                                      {#<h1>Oba! Recebemos seu e-mail :D</h1>#}
                                      <p>
                                          <strong>Email cadastrado com sucesso!</strong><br/>
                                          Agora você receberá nossas dicas antes de todo mundo. <strong> \o/</strong>
                                      </p>
                                  </div>
                              </div>
                          </div>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
          </section>`;

			if (node) node.innerHTML = htmlError;
			else document.querySelector(".error-form").innerHTML = htmlError;
			const discountsNode = document.querySelector(`.${nome_feriado}-descontos`);
			if (discountsNode) discountsNode.remove();
		};

		const blogDestinosContent = document.querySelector(
			".blog-feriado .swiper-container .swiper-wrapper"
		);

		let aeroportosMaisBuscados;
		let JsonText;

		if (nome_feriado == "ano-novo") {
			aeroportosMaisBuscados = ["CWB", "POA", "BSB", "FOR", "RIO", "RIO", "POA", "BSB", "SAO"];
			JsonText = holidayAnoNovo;
		}
		if (nome_feriado == "carnaval") {
			aeroportosMaisBuscados = ["SSA", "RIO", "BHZ", "REC", "FOR", "SAO", "BHZ", "BSB", "POA"];
			JsonText = holidayCarnaval;
		}
		if (nome_feriado == "dia-das-maes") {
			aeroportosMaisBuscados = ["BSB", "MAO", "SSA", "BEL", "CWB", "IGU", "THE", "NAT", "FOR"];
			JsonText = holidayDiaDasMaes;
		}
		if (nome_feriado == "dia-do-trabalho") {
			aeroportosMaisBuscados = ["CWB", "RIO", "REC", "GYN", "VCP", "FLN", "BHZ", "VIX", "FOR"];
			JsonText = holidayDiaDoTrabalho;
		}
		if (nome_feriado == "dia-dos-namorados") {
			aeroportosMaisBuscados = ["POA", "FEN", "NAT", "RIO", "RIO", "RIO", "PMW", "BYO", "SSA"];
			JsonText = holidayDiaDosNamorados;
		}
		if (nome_feriado == "festa-junina") {
			aeroportosMaisBuscados = ["REC", "SSA", "AJU", "FOR", "JPA", "MCZ", "SAO", "RIO", "NAT"];
			JsonText = holidayFestaJunina;
		}
		if (nome_feriado == "independencia-do-brasil") {
			aeroportosMaisBuscados = ["FOR", "SAO", "SSA", "REC", "CWB", "GYN", "SLZ", "FLN", "POA"];
			JsonText = holidayIndependenciaDoBrasil;
		}
		if (nome_feriado == "nossa-senhora-aparecida") {
			aeroportosMaisBuscados = ["SAO", "GYN", "FOR", "SAO", "GYN", "BHZ", "RIO", "CWB", "POA"];
			JsonText = holidayNossaSenhora;
		}
		if (nome_feriado == "proclamacao-da-republica") {
			aeroportosMaisBuscados = ["FOR", "SAO", "SSA", "REC", "CWB", "GYN", "SLZ", "FLN", "POA"];
			JsonText = holidayProclamacaoDaRepublica;
		}
		if (nome_feriado == "semana-santa-pascoa") {
			aeroportosMaisBuscados = ["NAT", "POA", "BHZ", "BHZ", "SSA", "REC", "GYN", "GYN", "SAO"];
			JsonText = holidaySemanaSanta;
		}
		if (nome_feriado == "corpus-christi") {
			aeroportosMaisBuscados = ["SAO", "BSB", "RIO", "FOR", "POA", "SSA", "REC", "BHZ", "GYN"];
			JsonText = holidayCorpusChristi;
		}
		if (nome_feriado == "finados") {
			aeroportosMaisBuscados = ["REC", "RIO", "SAO", "BSB", "BHZ", "POA", "FOR", "SSA", "MAO"];
			JsonText = holidayFinados;
		}

		const differenceMonth = moment().diff(minDate, "months");
		const differenceDay = moment().diff(minDate, "days");
		const trendsBox = document.getElementById("trendsDate-box");

		if (differenceMonth < -11) {
			if (trendsBox && trendsBox.parentElement) {
				trendsBox.parentElement.remove();
			}

			createErrorHtml(true);
		} else if (differenceDay > 0) {
			if (trendsBox && trendsBox.parentElement) {
				trendsBox.parentElement.remove();
			}

			createErrorHtml(false);
		} else {
			try {
				const trendsBox = document.getElementById("trendsDate-box");
				if (trendsBox) {
					const errorCallback = () => {
						trendsBox.parentNode.querySelector(".title-box").remove();
						createErrorHtml(false, { node: trendsBox, nome_feriado });
					};

					nanoajax.ajax(
						{
							url: `${NEARBY_PLACES_API}/airports?max=1`,
							timeout: 5000,
							method: "GET"
						},
						function(codeGeo, responseTextGeo, request) {
							if (codeGeo !== 200 || !responseTextGeo || !JSON.parse(responseTextGeo).length) {
								new Trends(trendsBox, [], {
									mindate: minDate,
									maxdate: maxDate,
									route: "trends",
									errorCallback
								});

								return false;
							}

							const geoData = JSON.parse(responseTextGeo);
							const groupIATA = geoData.filter(airport => airport.group);
							if (groupIATA.length > 0) {
								stretchFrom.decorateField(document.querySelector(`#${stretchFrom.elm.id}`), {
									city: groupIATA[0].city,
									iata: groupIATA[0].group,
									name: "Todos",
									country: groupIATA[0].country == "Brazil" ? "BR" : "" //TODO - retornar países com abreviação de dois caracteres do banco
								});
							} else {
								stretchFrom.decorateField(document.querySelector(`#${stretchFrom.elm.id}`), {
									city: airportData[0].city,
									iata: airportData[0].iata,
									name: airportData[0].name,
									country: airportData[0].country == "Brazil" ? "BR" : ""
								});
							}

							const iataGeo = geoData[0]["group"] ? geoData[0]["group"] : geoData[0]["iata"];
							const iataArray = [];
							iataArray.push(iataGeo);

							new Trends(trendsBox, iataArray, {
								mindate: minDate,
								maxdate: maxDate,
								route: "trends",
								errorCallback
							});
						}
					);
				}
			} catch (e) {
				createErrorHtml();
			}
		}

		nanoajax.ajax(
			{
				url: `https://www.maxmilhas.com.br/blog/?feed=rss2&s=${slugify(nome_feriado)}`,
				method: "GET"
			},
			function(code, responseText, request) {
				let data;

				document.querySelector(".blog-feriado .loading").remove();

				if (code === 200 && responseText) {
					if (window.DOMParser) {
						const parser = new DOMParser();
						data = parser.parseFromString(responseText, "text/xml");
					} else {
						// Internet Explorer
						data = new ActiveXObject("Microsoft.XMLDOM");
						data.async = false;
						data.loadXML(responseText);
					}

					const channelXML = data.getElementsByTagName("channel")[0];

					const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

					const createItemsOnScreen = (channelXML, length) => {
						sizeBlog = length;

						for (var i = 0; i < limitPostsBlog; i++) {
							const item = channelXML.getElementsByTagName("item")[i];

							if (!item) {
								var swiperBlogFriday = new Swiper(".blog-feriado .swiper-container", {
									pagination: {
										el: null,
										clickable: true
									},
									simulateTouch: false,
									loop: false,
									slidesPerView: sizeBlog,
									slidesPerGroup: sizeBlog,
									slidesPerColumn: 1,
									spaceBetween: 30,
									navigation: {
										nextEl: ".blog-destino .swiper-button-next",
										prevEl: ".blog-destino .swiper-button-prev",
									},
									breakpoints: {
										768: {
											pagination: {
												el: ".blog-feriado .swiper-pagination",
											},
											simulateTouch: true,
											slidesPerView: 1,
											slidesPerGroup: 1,
											slidesPerColumn: 1,
											loop: true
										}
									}
								});

								return false;
							}

							const title = item.getElementsByTagName("title")[0].textContent;
							const link = item.getElementsByTagName("link")[0].textContent;
							const image = item.getElementsByTagName("image")[0]
								? item.getElementsByTagName("image")[0].textContent
								: "<img width='355' height='237' src='../../../../img/defaults/img-default-770x305.jpg' class='attachment-image-372 size-image-372 wp-post-image' />";
							const description = item.getElementsByTagName("description")[0].textContent;

							let columns = "";

							if (length == 3) {
								columns = " col-md-4";
							} else if (length == 2 && i == 0) {
								columns = " col-md-4 col-md-offset-2";
							} else if (length == 2 && i != 0) {
								columns = " col-md-4";
							} else {
								columns = " col-md-3";
							}

							blogDestinosContent.innerHTML += `<div class="swiper-slide">
																		<a href="${link.replace(/https:\/\/maxmilhas\.wpengine\.com/, 'https://www.maxmilhas.com.br/blog')}" class="card-largetitle blog" target="_blank">
																				<div class="card-largetitle-item">
																						<div class="card-largetitle-item--title">
																								${image}
																						</div>
																						<div class="card-largetitle-item--info">
																								<div class="card-largetitle-item--info-infos">
																										<h4>${title}</h4>
																										<p class="card-largetitle-item--info-text">
																										${description}</p>
																								</div>
																						</div>
																				</div>
																		</a>
																</div>`;
						}

						sizeBlog = sizeBlog > 4 ? (sizeBlog = 4) : (sizeBlog = sizeBlog);

						var swiperBlogFriday = new Swiper(".blog-feriado .swiper-container", {
							pagination: {
								el: null,
								clickable: true,
							},
							simulateTouch: false,
							loop: false,
							slidesPerView: sizeBlog,
							slidesPerGroup: sizeBlog,
							slidesPerColumn: 1,
							spaceBetween: 30,
							navigation: {
								nextEl: ".blog-destino .swiper-button-next",
								prevEl: ".blog-destino .swiper-button-prev",
							},
							breakpoints: {
								768: {
									pagination: {
										el: ".blog-feriado .swiper-pagination",
									},
									simulateTouch: true,
									slidesPerView: 1,
									slidesPerGroup: 1,
									slidesPerColumn: 1,
									loop: true
								}
							}
						});
					};

					if (length < 2) {
						nanoajax.ajax(
							{
								url: `https://www.maxmilhas.com.br/blog/?feed`,
								method: "GET"
							},
							function(code, responseText, request) {
								if (window.DOMParser) {
									const parser = new DOMParser();
									data = parser.parseFromString(responseText, "text/xml");
								} else {
									// Internet Explorer
									data = new ActiveXObject("Microsoft.XMLDOM");
									data.async = false;
									data.loadXML(responseText);
								}

								const channelXML = data.getElementsByTagName("channel")[0];

								const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

								createItemsOnScreen(channelXML, length);
							}
						);
					} else {
						createItemsOnScreen(channelXML, length);
					}
				} else {
					blogDestinosContent.innerHTML += `<div class="col-xs-16">
                    <a href="#" class="card-largetitle blog" target="_blank">
                        <div class="card-largetitle-item">
                            <div class="card-largetitle-item--title">
                                <img src="#" alt="">
                            </div>
                            <div class="card-largetitle-item--info">
                                <div class="card-largetitle-item--info-infos">
                                    <h4>Ops!</h4>
                                    <p class="card-largetitle-item--info-text">Ocorreu um erro, tente novamente.</p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>`;
				}
			}
		);

		const buscaAeroportosMaisBuscados = () => {
			const buscaPassagensDestinyContent = document.querySelector(
				".discount-destiny .swiper-wrapper"
			);

			const urlAssetsDestiny = document
				.querySelector(".discount-destiny")
				.getAttribute("data-url-destiny");

			let requestsAeroportosMaisBuscados = [];
			let pricesDestiny = [];

			aeroportosMaisBuscados.map((aeroporto, i) => {
				requestsAeroportosMaisBuscados.push(
					new Promise((resolve, reject) => {
						const differenceMonths = moment().diff(minDate, "months");
						const differenceDay = moment().diff(minDate, "days");

						if (differenceMonths < -11 || differenceDay > 0) {
							resolve();

							return false;
						}

						return nanoajax.ajax(
							{
								url: `${urlBuscaPassagens}/best-prices/flights?to=${aeroporto}&min_outbound_date=${minDate}&max_outbound_date=${maxDate}&size=${limitBuscaPassagensAeroporto}&exclusivo_maxmilhas=false`,
								method: "GET"
							},
							function(code, responseText, request) {
								if (code !== 200 || !responseText || !JSON.parse(responseText).length) {
									resolve();

									return false;
								}

								const data = JSON.parse(responseText);
								const item = data[0];

								const city = JsonText[i].city;

								const citySlug = slugify(city, { lower: true });
								const price = formatCurrency(item.best_price_mm_w_taxes);

								pricesDestiny.push({
									name: citySlug,
									value: price
								});

								resolve();
							}
						);
					})
				);
			});

			Promise.all(requestsAeroportosMaisBuscados)
				.then(() => {
					pricesDestiny.map(item => {
						const cardItem = document.querySelector(
							`.discount-destiny .${item["name"]}-card .card-largetitle-item--info`
						);

						if (cardItem) {
							cardItem.innerHTML += `<h5 class="card-largetitle-item--info-price">${
								item["value"]
							}</h5>`;
						}
					});

					var swiperDiscount = new Swiper("#swiper-discount-destiny .swiper-container", {
						pagination: {
							el: "#swiper-discount-destiny .swiper-pagination",
							clickable: true
						},
						simulateTouch: false,
						loop: false,
						slidesPerView: 3,
						slidesPerGroup: 3,
						slidesPerColumn: 1,
						spaceBetween: 30,
						navigation: {
							nextEl: "#swiper-discount-destiny .swiper-button-next",
							prevEl: "#swiper-discount-destiny .swiper-button-prev",
						},
						breakpoints: {
							768: {
								simulateTouch: true,
								slidesPerView: 1,
								slidesPerGroup: 1,
								slidesPerColumn: 1,
								loop: true
							}
						}
					});
				})
				.catch(erro => {
					console.error("Ocorreu um erro ao buscar preços dos destinos", erro);
				});
		};

		buscaAeroportosMaisBuscados();

		var swiperDiscount = new Swiper("#swiper-discount-destiny .swiper-container", {
			pagination: {
				el: "#swiper-discount-destiny .swiper-pagination",
				clickable: true
			},
			simulateTouch: false,
			loop: false,
			slidesPerView: 3,
			slidesPerGroup: 3,
			slidesPerColumn: 1,
			spaceBetween: 30,
			navigation: {
				nextEl: "#swiper-discount-destiny .swiper-button-next",
				prevEl: "#swiper-discount-destiny .swiper-button-prev",
			},
			breakpoints: {
				768: {
					simulateTouch: true,
					slidesPerView: 1,
					slidesPerGroup: 1,
					slidesPerColumn: 1,
					loop: true
				}
			}
		});
	}
};
